import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import Button from '@shared/ui/button'
import Search from '@shared/ui/search'

import styles from './PickupView.module.scss'

enum ViewState {
  INITIAL = 'initial',
  DETAILS = 'details',
  MAP = 'map',
}

type ControlsProps = {
  view: ViewState;
  handleControlsCallback: () => void;
  isSearchMode: boolean;
  setSearchMode: (mode: boolean) => void;
  isTablet: boolean;
} & React.ComponentProps<typeof Search>;

export const PickupControls = ({
  view,
  handleControlsCallback,
  isSearchMode,
  setSearchMode,
  isTablet,
  ...searchProps
}: ControlsProps) => {
  const { t } = useTranslation('modalDelivery')
  const { t: ti } = useTranslation('info')

  if (view === ViewState.DETAILS) {
    return (
      <span className={styles.content__back} onClick={handleControlsCallback}>
        <ReactSVG className={styles.control} src="/icons/back-arrows.svg" />
        {ti('location.button')}
      </span>
    )
  }

  if (!isSearchMode) {
    return (
      <>
        <p className={styles.content__desc}>{t('desc')}</p>
        <Button
          onClick={() => setSearchMode(true)}
          type="submit"
          theme="secondary"
          size={isTablet ? 'medium' : 'large'}
        >
          {t('button.add-shop')}
        </Button>
      </>
    )
  }

  return <Search className={styles.content__search} {...searchProps} />
}
